function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAwardFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.208 11.237c-.402-.131-.883-.118-1.186-.058a1.022 1.022 0 11-.403-2.005c.553-.11 1.408-.148 2.231.121.871.285 1.743.937 2.052 2.167.19.756.078 1.624-.123 2.391a10.328 10.328 0 01-.938 2.31c-.38.69-.854 1.354-1.367 1.788-.251.212-.595.441-1.012.52a1.508 1.508 0 01-1.37-.416 1.018 1.018 0 010-1.446c.292-.29.714-.369 1.077-.239.239-.213.557-.625.87-1.192.318-.573.59-1.23.75-1.842.168-.639.185-1.112.118-1.378-.102-.406-.344-.605-.699-.72zM4.792 11.237c.402-.131.883-.118 1.186-.058a1.022 1.022 0 10.403-2.005c-.553-.11-1.409-.148-2.231.121-.871.285-1.743.937-2.052 2.167-.19.756-.078 1.624.123 2.391.209.793.548 1.606.937 2.31.381.69.855 1.354 1.368 1.788.25.212.595.441 1.012.52.483.093.986-.036 1.369-.416.402-.4.402-1.047 0-1.446a1.033 1.033 0 00-1.076-.239c-.24-.213-.557-.625-.87-1.192a8.303 8.303 0 01-.75-1.842c-.168-.639-.185-1.112-.118-1.378.102-.406.344-.605.699-.72z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 21.636c3.483 0 6.25-2.78 6.25-6.142V9.091H8.25v6.403c0 3.362 2.767 6.142 6.25 6.142zm8.333-6.142c0 4.547-3.73 8.233-8.333 8.233-4.602 0-8.333-3.686-8.333-8.233v-7.58A.92.92 0 017.093 7h14.814a.92.92 0 01.926.915v7.58z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.458 28.954v-5.75h2.084v5.75h-2.084z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51 28.693c0-.577.467-1.045 1.042-1.045h9.896c.575 0 1.042.468 1.042 1.045 0 .578-.467 1.046-1.042 1.046H9.552a1.044 1.044 0 01-1.042-1.046z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 1l.99 2.51L30 4.5l-2.51.99L26.5 8l-.99-2.51L23 4.5l2.51-.99L26.5 1z",
    fill: props.color
  }));
}

export default SvgIconAwardFilled;